import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../icon'
import VPFModal from './VPFModal'
import styles from './VPFBadge.module.scss'

export default function VPFBadge({
  event,
  className = '',
  stopPropagation = false,
  onVPFClick,
}) {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)

  if (!event?.volunteer_pay_forward) return null

  const handleClick = (e) => {
    if (stopPropagation) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (onVPFClick) {
      onVPFClick(event)
    } else {
      setShowModal(true)
    }
  }

  const handleHide = () => setShowModal(false)

  return (
    <>
      <button
        type="button"
        className={`${styles.badge} ${className}`}
        onClick={handleClick}
        aria-label={t('event.vpf.modal.title')}
      >
        <span className={styles.hearts}>
          <Icon name="heart" className={styles.heartBack} />
          <Icon name="heart" className={styles.heartFront} />
        </span>
        <span className={styles.text}>VPF</span>
      </button>
      {!onVPFClick && (
        <VPFModal show={showModal} onHide={handleHide} />
      )}
    </>
  )
}
